import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CardState, PerfTableColumn } from "../card-types";

@Component({
  selector: "perf-table-card",
  templateUrl: "./perf-table-card.component.html",
  styleUrls: ["../../dashboard-section.scss", "../../dashboard-section-v2.scss"],
  styles: [":host { display: contents; }"],
})
export class PerfTableCardComponent {
  @Input() title: string;
  @Input() hint: string;
  @Input() state: CardState<any>;
  @Input() nameColumn: PerfTableColumn;
  @Input() valueColumns: PerfTableColumn[] = [];
  @Input() showHeader: boolean = true;
  @Input() extraTableClass: string = "";
  @Input() noDataMessage: string = "Nothing to see here yet.";
  @Input() showExport: boolean = true;
  @Input() showDashboardLink: boolean = false;
  @Input() isReport: boolean = false;
  @Input() comingSoon: boolean = false;
  @Input() rowLimit: number;
  @Output() exportClick = new EventEmitter<void>();
  @Output() dashboardClick = new EventEmitter<void>();
}
